module.exports = __webpack_public_path__ + "media/flags/ee-cfa469c9.svg";